import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['radio', 'checkbox', 'dialog', 'enableContent', 'disableContent']

  static values = {
    beforeConfirm: String
  }

  _pendingChecked = null

  askConfirmation (event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    if (this.hasCheckboxTarget) {
      this._pendingChecked = this.checkboxTarget.checked
      this.#updateContentVisibility()
    }

    this.dialogTarget.showModal()
  }

  confirm () {
    if (this.hasCheckboxTarget) {
      this.checkboxTarget.checked = this._pendingChecked
      this.checkboxTarget.dispatchEvent(new CustomEvent('confirmed', { bubbles: true }))
    } else {
      const checkedRadio = this.radioTargets.find(input => input.checked)
      checkedRadio?.dispatchEvent(new CustomEvent('confirmed', { bubbles: true }))
    }
    this.close()
  }

  cancel () {
    if (!this.hasCheckboxTarget) {
      const targetRadio = this.radioTargets.find(input => input.value === this.beforeConfirmValue)
      if (targetRadio) targetRadio.checked = true
    }
    this.close()
  }

  close () {
    this._pendingChecked = null
    this.dialogTarget.close()
  }

  #updateContentVisibility () {
    this.enableContentTargets.forEach(el => { el.hidden = !this._pendingChecked })
    this.disableContentTargets.forEach(el => { el.hidden = this._pendingChecked })
  }
}
